import React, { useContext, useState, useEffect, useRef } from 'react'

import { DataContext } from '../DataContext'
import { MapControlContext } from '../MapControlContext'
import TooltipLoading from './TooltipLoading'
import TooltipData from './TooltipData'

const TIMEOUT = 500

export default ({ left, top, right, bottom, facilityID }) => {
    const tooltipRef = useRef(null)
    const [timeoutID, setTimeoutID] = useState(null)
    const { tooltipData, tooltipFilterData, tooltipLoading, isSubmissionsMap } = useContext(
        DataContext
    )
    const { activeControl } = useContext(MapControlContext)

    // display logic 
    const [display, setDisplay] = useState('none')

    // when a new feature is highlighted,
    // set display block
    useEffect(() => {
        if ((facilityID && !activeControl) || (facilityID && activeControl === 'select')) {
            clearTimeout(timeoutID)
            setDisplay('block')
        }
        else {
            const tID = setTimeout(() => setDisplay('none'), TIMEOUT)
            setTimeoutID(tID)
        }
    }, [facilityID])

    // when the tooltip loads,
    // setup mouseenter and mouseleave
    // functions to ensure mouseover
    // prevents tooltip from hiding
    useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.onmouseenter = () => setDisplay('block')
            // tooltipRef.current.onmouseleave = () => setDisplay('none')
        }
    }, [tooltipRef.current])

    return (
        <div
            className="tooltipWrapper"
            style={{
                left,
                right,
                bottom,
                top,
                display,
            }}
            ref={tooltipRef}
        >
            {tooltipLoading ? (
                <TooltipLoading />
            ) : (
                <TooltipData
                    tooltipData={tooltipData}
                    tooltipFilterData={tooltipFilterData}
                    isSubmissionsMap={isSubmissionsMap}
                />
            )}
        </div>
    )
}
